jQuery(function($) {
  $('.blog-image-slider').each(function () {
    const animationSpeed = $(this)
      .find('#animation_duration_milliseconds').val()

    // Time between between slides
    const slideSpeed = parseFloat($(this).find('#seconds_between_transitions').val()) * 1000

    $(this).slides({
      slideSpeed,
      animationSpeed,
      rootClass: 'blog-image-slider'
    })
  })
});



// WEBPACK FOOTER //
// ./scripts/acf-blocks/blog-image-slider.js